"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addStripePayment = void 0;
const types_1 = require("../types");
const checkout_frontend_library_1 = require("@bold-commerce/checkout-frontend-library");
const src_1 = require("..");
function addStripePayment(event, stripeGatewayId) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const { order_total } = (0, checkout_frontend_library_1.getApplicationState)();
        const token = event.token;
        const card = token.card;
        let success = false;
        const { firstName, lastName } = (0, src_1.getFirstAndLastName)(event.payerName);
        yield (0, src_1.callGuestCustomerEndpoint)(firstName, lastName, (_a = event.payerEmail) !== null && _a !== void 0 ? _a : '').then((customerResult) => __awaiter(this, void 0, void 0, function* () {
            if (customerResult.success) {
                const shippingAddress = event.shippingAddress;
                const address = (0, src_1.formatStripeShippingAddress)(shippingAddress);
                yield (0, checkout_frontend_library_1.updateShippingAddress)(address, types_1.API_RETRY).then((shippingResult) => __awaiter(this, void 0, void 0, function* () {
                    if (shippingResult.success) {
                        const billingAddress = (0, src_1.formatStripeBillingAddress)(card, event.payerName, event.payerPhone);
                        yield (0, checkout_frontend_library_1.setBillingAddress)(billingAddress, types_1.API_RETRY).then((billingResult) => __awaiter(this, void 0, void 0, function* () {
                            if (billingResult.success) {
                                const payment = {
                                    token: token.id,
                                    gateway_public_id: stripeGatewayId,
                                    currency: card.currency,
                                    amount: order_total
                                };
                                yield (0, checkout_frontend_library_1.addPayment)(payment, types_1.API_RETRY).then((paymentResult) => __awaiter(this, void 0, void 0, function* () {
                                    if (paymentResult.success) {
                                        success = true;
                                    }
                                }));
                            }
                        }));
                    }
                }));
            }
        }));
        if (success) {
            event.complete && event.complete('success');
            (0, src_1.orderProcessing)();
        }
        else {
            event.complete && event.complete('fail');
        }
    });
}
exports.addStripePayment = addStripePayment;
